import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import lottie, { AnimationItem } from 'lottie-web';

/**
 * The same folding-smap animation used for the toolbar's "generating" icon
 * (top-toolbar.component.ts, assets/lottie/symbol-smap.json), rendered large
 * and centered as the canvas's map-loading indicator.
 */
@Component({
  selector: 'app-smap-loading-animation',
  standalone: true,
  template: `<div class="smap-loading-animation" [class.dark]="dark" [style.width.px]="size" [style.height.px]="size" #container></div>`,
  styles: [`
    .smap-loading-animation {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        display: block;
        width: 100%;
        height: 100%;
      }

      &.dark svg {
        // The animation is pure black/white, so inverting swaps it to white-on-black.
        filter: invert(1);
      }
    }
  `]
})
export class SmapLoadingAnimationComponent implements AfterViewInit, OnDestroy {
  @Input() size = 192; // 8x the 24px toolbar icon
  @Input() dark = false;
  @ViewChild('container') containerRef!: ElementRef<HTMLElement>;

  private static readonly LOTTIE_PATH = 'assets/lottie/symbol-smap.json';
  private instance: AnimationItem | null = null;

  ngAfterViewInit(): void {
    this.instance = lottie.loadAnimation({
      container: this.containerRef.nativeElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: SmapLoadingAnimationComponent.LOTTIE_PATH,
    });
  }

  ngOnDestroy(): void {
    this.instance?.destroy();
    this.instance = null;
  }
}
